<template>
  <div v-if="loading">
    <div class="card card-layout-spinner">
      <content-spinner/>
    </div>
  </div>
  <div v-else class="card card-layout" :class="[{ 'card-interactive': interactive }]" @click="clicked">
    <div class="card-layout-header">
      <div class="card-layout-title">
        <span class="card-title text-primary">
          <slot name="title"/>
        </span>
        <span class="card-subtitle text-primary">
          <slot name="subtitle"/>
        </span>
      </div>
      <div v-if="prompt" class="card-prompt">
        <prompt>{{ prompt }}</prompt>
      </div>
    </div>
    <div class="card-layout-content">
      <span class="card-value text-primary b">
        <slot name="value"/>
      </span>
      <span class="card-unit text-primary">
        <slot name="unit"/>
      </span>
    </div>
  </div>
</template>

<script>
import ContentSpinner from '@/components/ui/progress/ContentSpinner.vue'
import Prompt from '@/components/common/Prompt.vue'

export default {
  props: ['loading', 'prompt', 'interactive'],
  components: {
    ContentSpinner,
    Prompt
  },
  methods: {
    clicked () {
      if (this.interactive) this.$emit('card-clicked')
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  padding: 0;
  background-color: white;
  line-height: 1.5;
  border-radius: .3rem;
  box-shadow: 0px 1px 3px 0px rgba(210,218,224,.8);
  &-interactive {
    cursor: pointer;
    transition: box-shadow ease-in-out .15s;
    &:hover {
      box-shadow: 1px 2px 4px 1px rgba(210,218,224,.6), 3px 3px 5px 2px rgba(210,218,224,.3);
    }
  }
  &-layout {
    &-spinner {
      display: flex;
      justify-content: center;
      padding: 1rem 1rem;
    }
    &-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    &-title {
      padding: .5rem 1rem .5rem 1rem;
    }
    &-content {
      display: flex;
      justify-content: flex-start;
      align-items: baseline;
      padding: .5rem 1rem .5rem 1rem;
    }
  }
  &-prompt {
    align-self: flex-start;
    padding: .5rem;
  }
  &-title {
    display: block;
    font-size: .85rem;
    font-weight: bold;
  }
  &-subtitle {
    display: block;
    font-size: .75rem;
  }
  &-value {
    font-size: 1rem;
  }
  &-unit {
    font-size: .75rem;
    margin-left: .25rem
  }
}
@media screen and (min-width: 30em) and (max-width: 80em) {
  .card {
    &-title {
      font-size: .85rem;
    }
    &-subtitle {
      font-size: .85rem;
    }
    &-value {
      font-size: 1rem;
    }
    &-unit {
      font-size: .75rem;
    }
  }
}
@media screen and (min-width: 80em) {
  .card {
    &-title {
      font-size: .85rem;
    }
    &-subtitle {
      font-size: .85rem;
    }
    &-value {
      font-size: 1rem;
    }
    &-unit {
      font-size: .85rem;
    }
  }
}
</style>
